import Bishop from './Bishop';
import King from './King';
import Knight from './Knight';
import Pawn from './Pawn';
import Queen from './Queen';
import Rook from './Rook';

export default {
  Bishop,
  King,
  Knight,
  Pawn,
  Queen,
  Rook,
}


// WEBPACK FOOTER //
// ./src/assets/constructors/pieces.js